import i18n from "@/i18n";

// 场景表格配置
export const sceneTableConfig = () => {
    return {
        firstScene: {
            columns: [
                {
                    colId: "ranking",
                    header: i18n.t("zhiji.hotSpot.ranking"),
                    type: "Text",
                    width: "15%"
                },
                {
                    colId: "classify",
                    header: i18n.t("zhiji.hotSpot.classify"),
                    type: "Text",
                    width: "30%"
                },
                {
                    colId: "satisfaction",
                    header: i18n.t("zhiji.satisfaction.satisfaction"),
                    type: "Text",
                    width: "30%"
                },
                {
                    colId: "evaNum",
                    header: i18n.t("zhiji.satisfaction.evaNum"),
                    type: "Text",
                    width: "25%"
                }
            ],
            isHideFooter: true,
            pageLength: 10
        }
    };
};
export const hotQuestionConfig = () => {
    return {
        columns: [
            {
                colId: "ranking",
                header: i18n.t("zhiji.hotSpot.ranking"),
                type: "Text",
                width: "15%"
            },
            {
                colId: "question",
                header: i18n.t("zhiji.hotSpot.standardQues"),
                type: "Link",
                width: "30%"
            },
            {
                colId: "satisfaction",
                header: i18n.t("zhiji.satisfaction.satisfaction"),
                type: "Text",
                width: "30%"
            },
            {
                colId: "satisfyEvalNum",
                header: i18n.t("zhiji.satisfaction.satisfyEvalNum"),
                type: "Text",
                width: "30%"
            },
            {
                colId: "evaNum",
                header: i18n.t("zhiji.satisfaction.evaNum"),
                type: "Text",
                width: "25%"
            },
            {
                colId: "questionNum",
                header: i18n.t("zhiji.satisfaction.questionNum"),
                type: "Text",
                width: "25%"
            },
            {
                colId: "evalRate",
                header: i18n.t("zhiji.satisfaction.evalRate"),
                type: "Text",
                width: "25%"
            }
        ],
        isHideFooter: true,
        pageLength: 10
    };
};

// 奇数-升序 偶数-降序
export const satisfOptions = () => {
    return [
        {
            label: i18n.t("zhiji.satisfaction.satisfyDesc"),
            value: "1"
        },
        {
            label: i18n.t("zhiji.satisfaction.satisfyAsc"),
            value: "2"
        },
        {
            label: i18n.t("zhiji.satisfaction.evaluateDesc"),
            value: "3"
        },
        {
            label: i18n.t("zhiji.satisfaction.evaluateAsc"),
            value: "4"
        }
    ];
};

export const quesSatisfOptions = () => {
    return [
        ...satisfOptions(),
        {
            label: i18n.t("zhiji.satisfaction.satisfyEvalDesc"),
            value: "5"
        },
        {
            label: i18n.t("zhiji.satisfaction.satisfyEvalAsc"),
            value: "6"
        },
        {
            label: i18n.t("zhiji.satisfaction.questionDesc"),
            value: "7"
        },
        {
            label: i18n.t("zhiji.satisfaction.questionAsc"),
            value: "8"
        },
        {
            label: i18n.t("zhiji.satisfaction.evalRateDesc"),
            value: "9"
        },
        {
            label: i18n.t("zhiji.satisfaction.evalRateAsc"),
            value: "10"
        }
    ];
};
